/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useState } from 'react';
import Input from 'components/Fields/Input';

import { useSpecSheet } from 'containers/spec-sheet';
import { useDebounce } from 'hooks/useDebounce';

const Last: React.FC = () => {
  const {
    data: { data },
    actions,
  } = useSpecSheet();

  const last = data?.last || '';

  const [value, setValue] = useState(last);

  const handleChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setValue(value);
  };

  const saveChange = async () =>
    actions.changeSpecSheetData({ last: value.trim() });

  const autoSave = useDebounce(value);

  const handleSave = () => {
    if (last !== value) saveChange();
  };

  useEffect(() => {
    handleSave();
  }, [autoSave]);

  const isCompleted = !!value;

  return (
    <Input
      label="Last"
      value={value}
      name="last"
      onChange={handleChange}
      dataTest="last"
      isCompleted={isCompleted}
      handleBlur={() => handleSave()}
      placeholder="Click to add"
    />
  );
};

export default Last;
